module.exports = __webpack_public_path__ + "img/kid12.08791531.png";